export default function upperCase (input) {   
    if (!input) return ''
    input = input.toString()
    return input.toUpperCase()
}